import { useMutation } from '@tanstack/react-query';

import { Files } from '@/components/Dropzone';
import { useAxios } from '@/hooks/useAxios';

export interface BurpParseResponse {
  filepath: string;
  primary_url: string;
  message: string;
}

interface BurpParseParams {
  url?: string;
  file?: Files<'arrayBuffer'>[0];
}

/**
 * Hook to validate and parse Burp API definitions
 * Validates OpenAPI/Swagger files from URL or file content
 */
export const useBurpParse = () => {
  const axios = useAxios();

  return useMutation({
    mutationFn: async (params: BurpParseParams) => {
      let parsedParams = params.file
        ? parseBurpFile(params.file)
        : { url: params.url };

      const response = await axios.post<BurpParseResponse>(
        '/burp/parse',
        parsedParams
      );
      return response.data;
    },
  });
};

/**
 * Helper function to parse file content for Burp validation
 */
export const parseBurpFile = (file: Files<'arrayBuffer'>[0]) => {
  const fileContent = new TextDecoder().decode(file.content);
  return {
    filename: file.file.name,
    content: fileContent,
  };
};
